import { useCallback } from 'react';
import { useStorage } from './useStorage';
import { storage } from '../websocket/storage';
import { orchestrator } from '../websocket/orchestrator';
import {
  ImportType,
  ImportStorageState,
  DEFAULT_IMPORT_STATE,
  buildImportKey,
} from '../websocket/domains/import/import.types';

export function useImportProgress(type: ImportType) {
  const key = buildImportKey(type);
  const state = useStorage<ImportStorageState>(key) ?? DEFAULT_IMPORT_STATE;

  const requestImportStatus = useCallback(() => {
    orchestrator.send(key, { action: 'get_progress' });
  }, [key]);

  const setImportingState = useCallback((value: boolean) => {
    const prev = storage.get<ImportStorageState>(key) ?? DEFAULT_IMPORT_STATE;
    storage.set(key, { ...prev, isImporting: value });
  }, [key]);

  const clearImport = useCallback(() => {
    const prev = storage.get<ImportStorageState>(key) ?? DEFAULT_IMPORT_STATE;
    storage.set(key, { ...prev, currentImport: null });
  }, [key]);

  return {
    isImporting: state.isImporting,
    currentImport: state.currentImport,
    historyVersion: state.historyVersion,
    requestImportStatus,
    setImportingState,
    clearImport,
  };
}
